import Head from 'next/head'
import { useRouter } from 'next/router'
import { useTranslation } from '@mc/i18n'
import { DEFAULT_THUMBNAIL, OG_IMAGE_HEIGHT, SITE_NAME } from 'libs/constants'
import { getUrlWithoutQueryParams } from 'libs/utils'

export const Meta = () => {
  const { t } = useTranslation('@mc/next')
  const { asPath } = useRouter()

  return (
    <Head>
      <title>{t('categories.meta.title')}</title>
      <meta
        content='-VH0v01sv1yndHZzRTVr0Sk6D2e_xiEDT5b6Z9Ca9Qo'
        name='google-site-verification'
      />
      <meta content={getUrlWithoutQueryParams(asPath)} property='og:url' />
      <meta content={SITE_NAME} property='og:site_name' />
      <meta content={t('categories.meta.description')} name='description' />
      <meta content={t('categories.meta.keywords')} name='keywords' />
      <meta content={t('categories.meta.title')} property='og:title' />
      <meta
        content={t('categories.meta.fbDescription')}
        property='og:description'
      />
      <meta content={DEFAULT_THUMBNAIL} property='og:image' />
      <meta content={OG_IMAGE_HEIGHT} property='og:image:height' />
    </Head>
  )
}
